import {
  createStyles,
  Text,
  Space,
  Anchor,
  Box,
  Avatar,
  Group,
  ActionIcon,
  Title,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';
import ReactPlayer from 'react-player';
import { IconCircleCheck, IconArrowLeft } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const DelhiPoliceSwiftAssistance = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className={classes.container}>
      <Box className={classes.sectionCenter}>
        <Group spacing="md" align="center" className={classes.header}>
          <ActionIcon
            size="lg"
            variant="transparent"
            onClick={() => navigate('/home/operating')}
            className={classes.backButton}>
            <IconArrowLeft size={24} color="#0F1419" />
          </ActionIcon>
        </Group>

        <Space h="lg" />

        <Title order={2} className={classes.newsTitle}>
          Delhi Police provides swift assistance to woman in distress through
          Say Help App
        </Title>

        <Space h="xl" />

        <Box className={classes.tweetContainer}>
          <Group spacing="sm" align="flex-start" wrap="nowrap">
            <Avatar
              src="https://pbs.twimg.com/profile_images/1931589934789668864/cxGeCvri_400x400.jpg"
              size={48}
              radius="xl"
            />
            <Box style={{ flex: 1 }}>
              <Group spacing={4} align="center">
                <Text weight={700} size="md" className={classes.authorName}>
                  DCP Central Delhi
                </Text>
                <IconCircleCheck
                  size={18}
                  style={{ color: '#FFFFFF', fill: '#1DA1F2' }}
                />
                <Text size="sm" color="dimmed" className={classes.handle}>
                  @DCPCentralDelhi
                </Text>
              </Group>

              <Space h="sm" />

              <Text size="md" className={classes.tweetText}>
                Team of{' '}
                <Anchor
                  href="https://x.com/DCPCentralDelhi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.mention}>
                  @DCPCentralDelhi
                </Anchor>{' '}
                promptly responded to a SayHelp App alert from a woman in
                Dwarka facing harassment by her landlord & family. Unable to
                reach 112 due to network issues, she used{' '}
                <Anchor
                  href="https://x.com/hashtag/sayhelp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.hashtag}>
                  #sayhelp
                </Anchor>{' '}
                voice trigger saying "help" three times and her live location
                was sent to police. Police acted swiftly, ensuring her safety.{' '}
                <Anchor
                  href="https://x.com/hashtag/DPUpdates"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.hashtag}>
                  #DPUpdates
                </Anchor>
              </Text>

              <Space h="sm" />

              <Box className={classes.mentions}>
                <Anchor
                  href="https://x.com/DelhiPolice"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.mention}>
                  @DelhiPolice
                </Anchor>
                <br />
                <Anchor
                  href="https://x.com/LtGovDelhi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.mention}>
                  @LtGovDelhi
                </Anchor>
                <br />
                <Anchor
                  href="https://x.com/CPDelhi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.mention}>
                  @CPDelhi
                </Anchor>
                <br />
                <Anchor
                  href="https://x.com/Ravindra_IPS"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.mention}>
                  @Ravindra_IPS
                </Anchor>
                <br />
                <Anchor
                  href="https://x.com/IPSMadhurVerma"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.mention}>
                  @IPSMadhurVerma
                </Anchor>
              </Box>

              <Space h="md" />

              <Box
                className={
                  isPlaying
                    ? classes.videoWrapperPlaying
                    : classes.videoWrapperPreview
                }>
                <ReactPlayer
                  width="100%"
                  height="100%"
                  url="https://vimeo.com/1145220848"
                  className={classes.reactPlayer}
                  controls={true}
                  light={require('../../assets/delhi-police-woman-distress-cover.png')}
                  onPlay={() => setIsPlaying(true)}
                  config={{
                    vimeo: {
                      playerOptions: {
                        controls: true,
                        playsinline: false,
                      },
                    },
                  }}
                />
              </Box>

              <Space h="sm" />

              <Text size="sm" color="dimmed" className={classes.timestamp}>
                1:54 PM · Dec 9, 2025 · 180 Views
              </Text>
            </Box>
          </Group>

          <Space h="xl" />

          <Box className={classes.footer}>
            <Text size="sm" color="dimmed">
              Source:{' '}
              <Anchor
                href="https://x.com/dcpcentraldelhi/status/1998360666990919734"
                target="_blank"
                rel="noopener noreferrer">
                View original post on X
              </Anchor>
            </Text>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default DelhiPoliceSwiftAssistance;

const useStyles = createStyles(theme => ({
  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 40,
    paddingBottom: 40,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },

  header: {
    marginBottom: 16,
  },

  backButton: {
    '&:hover': {
      backgroundColor: 'rgba(15, 20, 25, 0.1)',
    },
  },

  pageTitle: {
    fontFamily: 'Poppins',
    color: '#0F1419',
    fontSize: 20,
  },

  newsTitle: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    color: themeColors.anchor,
    fontSize: 28,
    lineHeight: 1.3,
    textAlign: 'left',
  },

  tweetContainer: {
    backgroundColor: themeColors.white,
    border: '1px solid #E1E8ED',
    borderRadius: 16,
    padding: '16px 20px',
    fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  authorName: {
    fontFamily: 'Poppins',
    color: '#0F1419',
    fontSize: 15,
  },

  handle: {
    fontFamily: 'Poppins',
    color: '#536471',
    fontSize: 15,
  },

  tweetText: {
    fontFamily: 'Poppins',
    color: '#0F1419',
    fontSize: 15,
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },

  mention: {
    color: '#1DA1F2',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  hashtag: {
    color: '#1DA1F2',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  mentions: {
    fontFamily: 'Poppins',
    fontSize: 15,
    lineHeight: 1.4,
  },

  videoWrapperPreview: {
    position: 'relative',
    width: '100%',
    maxWidth: 450,
    paddingTop: '56.25%',
    maxHeight: 350,
    borderRadius: 16,
    overflow: 'hidden',
    border: '1px solid #E1E8ED',
  },

  videoWrapperPlaying: {
    position: 'relative',
    width: '100%',
    maxWidth: 450,
    height: 800,
    borderRadius: 16,
    overflow: 'hidden',
    border: '1px solid #E1E8ED',
  },

  reactPlayer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },

  timestamp: {
    fontFamily: 'Poppins',
    color: '#536471',
    fontSize: 15,
  },

  footer: {
    paddingTop: 16,
    borderTop: '1px solid #E1E8ED',
  },
}));
